/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Rehab_Ex_TwoInputs */

const en_for_whom_rehab_ex_two = /** @type {(inputs: For_Whom_Rehab_Ex_TwoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dead bug`)
};

const pl_for_whom_rehab_ex_two = /** @type {(inputs: For_Whom_Rehab_Ex_TwoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dead bug`)
};

/**
* | output |
* | --- |
* | "Dead bug" |
*
* @param {For_Whom_Rehab_Ex_TwoInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_rehab_ex_two = /** @type {((inputs?: For_Whom_Rehab_Ex_TwoInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Rehab_Ex_TwoInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_rehab_ex_two(inputs)
	return en_for_whom_rehab_ex_two(inputs)
});